export enum JobTab {
  All,
  Running,
  Failed,
}
